import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function RequireAdmin({ children }) {
  const { admin, booting } = useAuth();
  if (booting) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-bone"
        data-testid="admin-booting"
      >
        <div className="overline text-ink/50">Loading…</div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
